export enum AccountTypeEnum {
    'Conta poupança' = 1,
    'Conta corrente' = 0
}